export default "__VITE_ASSET__IdoOFsu0__"